import { TextContainer, TextStyle } from "@shopify/polaris";

const TemplateMessageCard = (props:any) =>{
    return (
    <div className="Polaris-Card w-100">
        <div className="Polaris-Card__Section break-word">
          <TextContainer>
            <TextStyle>
              <span>
                {props.whatsappText}
                <br />
                <br />
              </span>
            </TextStyle>
          </TextContainer>
        </div>
      </div>
    )
};
export default TemplateMessageCard;